import { motion } from "framer-motion";
import { Download } from "lucide-react";
import { useInstall } from "../../lib/install";
import { InstallGuide as InstallHelp } from "./InstallGuide";

export const InstallButton = () => {
  const { installed, install, help, closeHelp } = useInstall();
  if (installed) return null;

  return (
    <>
      <motion.button data-testid="install-app-button" onClick={install} className="sp-install" whileTap={{ scale: 0.95 }}
        initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }}>
        <Download size={15} /> Instalar app
      </motion.button>
      <InstallHelp open={help} onClose={closeHelp} />
    </>
  );
};
